import {
  Dispatch,
  Reducer,
  useReducer,
} from 'react';
import {
  SET_ADDITIONAL_COMMENTS,
  SET_COOPERATIVE_MATCH,
  SET_ERROR,
  SET_EXISTING_MATCHES,
  SET_SELECTED_COUNTRIES,
  SET_SELECTED_MATCHES,
  SET_SPECIAL_NOTES,
} from './actions';
import { MatchingStateProps } from './types';
import { Actions } from '../../types';

const initialState: MatchingStateProps = {
  additionalComments: '',
  cooperativeMatch: false,
  existingMatches: {},
  selectedCountries: undefined,
  selectedMatches: {},
  specialNotes: [],
};

const reducer: Reducer<MatchingStateProps, Actions> = (state, action): MatchingStateProps => {
  switch (action.type) {
    case SET_ADDITIONAL_COMMENTS:
      return {
        ...state,
        additionalComments: action.additionalComments,
      };
    case SET_COOPERATIVE_MATCH:
      return {
        ...state,
        cooperativeMatch: action.cooperativeMatch,
      };
    case SET_SELECTED_COUNTRIES:
      return {
        ...state,
        selectedCountries: action.countries,
      };
    case SET_SELECTED_MATCHES:
      return {
        ...state,
        selectedMatches: action.selectedMatches,
      };
    case SET_SPECIAL_NOTES:
      return {
        ...state,
        specialNotes: action.specialNotes,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case SET_EXISTING_MATCHES:
      return {
        ...state,
        existingMatches: action.existingMatches,
      };
    default:
      return state;
  }
};

const useMatchingReducer = () => {
  const [matching, dispatchMatching] = useReducer(reducer, initialState);

  return [matching, dispatchMatching] as [MatchingStateProps, Dispatch<Actions>];
};

export default useMatchingReducer;
